import AdvantageCard from '@/components_fbl/CardComponents/BusinessCards/AdvantageCard';
import DropDownWrapper from '@/components_fbl/dropDownComponents/DropDownWrapper';
import PrimaryHeading from '@/components_fbl/headingComponents/PrimaryHeading';
import { BusinessAdvantagesData } from '@/src/constants/Business/businessPageData';
import { Box, Grid } from '@mui/material';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

function AdvantagesSection() {
  const router = useRouter();
  useEffect(() => {
    // Check if there's a hash in the URL
    if (router.asPath.includes('#')) {
      const id = router.asPath.split('#')[1]; // Get the id from the hash
      const element = document.getElementById(id); // Find the element with that id
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' }); // Scroll to the element
      }
    }
  }, [router.asPath]);

  return (
    <DropDownWrapper component="section" id="advantages-section">
      <Box
        sx={{
          width: '100%',
          height: '100%',
          borderRadius: 4,

          py: { xs: 4, md: 6 },
          px: { xs: 2, md: 6 },
        }}
      >
        <PrimaryHeading
          sx={{ color: 'violetPalette.dark', mb: { xs: 2, md: 3 } }}
        >
          {BusinessAdvantagesData.title}
        </PrimaryHeading>
        <Grid container spacing={2}>
          {BusinessAdvantagesData
            ? Array.from(BusinessAdvantagesData.contents.slice(0, 2)).map(
                (data, index) => (
                  <Grid
                    xs={12}
                    md={6}
                    key={index}
                    item
                    sx={{ height: '100%', mt: { xs: 2, md: 0 } }}
                  >
                    <AdvantageCard item={data} />
                  </Grid>
                )
              )
            : null}
        </Grid>
        <Grid container spacing={2} mt={1}>
          {BusinessAdvantagesData
            ? Array.from(BusinessAdvantagesData.contents.slice(2)).map(
                (data, index) => (
                  <Grid
                    xs={12}
                    md={4}
                    key={index}
                    item
                    sx={{ height: '100%', mt: { xs: 2, md: 0 } }}
                  >
                    <AdvantageCard item={data} />
                  </Grid>
                )
              )
            : null}
        </Grid>
      </Box>
    </DropDownWrapper>
  );
}

export default AdvantagesSection;
